import { ProfilePageBannerData } from '@/modules/client-setting/type'
import { DataTable } from '@/common/ui/table/data-table'
import { columns, writeAccessorKeys } from './constants'
import useHasPermission from '@/common/hooks/useHasPermission'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useMemo } from 'react'

interface ProfilePageBannerTableProps {
	data: ProfilePageBannerData[]
	isLoading?: boolean
}

export default function ProfilePageBannerTable({
	data,
	isLoading,
}: ProfilePageBannerTableProps) {
	const hasWritePermission = useHasPermission(PermissionKeys.WEB_SETTING)

	const filteredColumns = useMemo(
		() =>
			columns.filter(
				(column) =>
					hasWritePermission ||
					('accessorKey' in column &&
						!writeAccessorKeys.includes(column.accessorKey)),
			),
		[hasWritePermission],
	)

	return (
		<div className="space-y-4">
			<DataTable columns={filteredColumns} data={data} isLoading={isLoading} />
		</div>
	)
}
